export enum TypePreferenceVacation {
  Favori,
  Possible,
  Interdit
}